// src/api/useSignUp.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const fetchCloseAssignment = ({ id }) => {
  return api.put(`/admin/agenda/${id}/close`);
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useCloseAssignmentQuery = () => {
  return useMutation({
    mutationFn: fetchCloseAssignment,
  });
};
